<h2 mat-dialog-title>Zur Gesamtplanung hinzufügen</h2>

<mat-dialog-content class="planning-form">
  <p class="form-hint muted">
    <mat-icon>info_outline</mat-icon>
    Bestehende Benutzerkonten erscheinen danach in der Gesamtplanung – auch ohne Team. In einer
    Teamplanung erscheinen sie erst, wenn sie dem Team zugeordnet werden. Es werden keine Konten angelegt.
  </p>

  <mat-form-field appearance="outline" *ngIf="data.candidates.length; else none">
    <mat-label>Mitarbeiter auswählen</mat-label>
    <mat-select [(ngModel)]="selectedIds" multiple>
      <div class="select-search">
        <input class="select-search-input" placeholder="Name oder E-Mail suchen …" [(ngModel)]="search"
          (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      </div>
      <mat-option *ngFor="let user of options" [value]="user.userId">
        {{ user.name }}<span class="option-mail" *ngIf="user.email"> · {{ user.email }}</span>
        <span class="option-mail" *ngIf="isPlannedByTeam(user.userId)"> · bereits über Team in der Planung</span>
      </mat-option>
    </mat-select>
    <mat-hint>{{ selectedIds.length }} ausgewählt</mat-hint>
  </mat-form-field>

  <ng-template #none>
    <p class="form-hint muted">
      <mat-icon>check_circle_outline</mat-icon>
      Alle Benutzerkonten sind bereits manuell in der Gesamtplanung.
    </p>
  </ng-template>

  <div class="chips" *ngIf="selected.length">
    <span class="chip" *ngFor="let user of selected">
      <span class="avatar small">{{ user.name.charAt(0).toUpperCase() }}</span>
      {{ user.name }}
      <span class="badge muted" *ngIf="isPlannedByTeam(user.userId)" matTooltip="Bleibt auch ohne Team in der Gesamtplanung">
        <mat-icon>groups</mat-icon>im Team
      </span>
      <button type="button" class="chip-remove" (click)="remove(user.userId)" [attr.aria-label]="user.name + ' entfernen'">
        <mat-icon>close</mat-icon>
      </button>
    </span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Abbrechen</button>
  <button mat-flat-button color="primary" [disabled]="!selectedIds.length" (click)="confirm()">
    <mat-icon>person_add</mat-icon>
    {{ selectedIds.length > 1 ? selectedIds.length + ' Mitarbeiter hinzufügen' : 'Hinzufügen' }}
  </button>
</mat-dialog-actions>
